// keys are 'locale' names in next.config.js (i18n section)
const sites = {
    global: {
        adminOktaGroups: ["CRF_STAFF", "ENCORE_STAFF", "DEVTENCE_STAFF"],
        premiumAccessOktaGroups: ["TCTMD-GOLD-USERS", "TCTMD-PLATINUM-USERS"],
    },
    "tht2023-archive": {
        craftId: 15,
        emmaId: 193,
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [
            "THT-2023_ALL_ACCESS",
            "THT-2023_ONLINE_ACCESS",
            "TCTMD-GOLD-USERS",
            "TCTMD-PLATINUM-USERS",
        ],
    },
    "tht2024-archive": {
        craftId: 30,
        emmaId: 205,
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [
            "THT-2024_ALL_ACCESS",
            "THT-2024_ONLINE_ACCESS",
            "TCTMD-GOLD-USERS",
            "TCTMD-PLATINUM-USERS",
        ],
    },
    "tht2025-archive": {
        craftId: 40,
        emmaId: 220,
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
    },
    "tht2026-archive": {
        craftId: 54,
        emmaId: 230,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
    },
    "tht2027std-archive": {
        craftId: 68,
        emmaId: 0,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
    },
    tht2027: {
        craftId: 66,
        emmaId: 239,
        fullDomain: "www.thtmeeting.com",
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
    },
    "tct2021-archive": {
        craftId: 5,
        emmaId: 177,
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: ["TCT2021_FULL_ACCESS", "TCT2021_ONDEMAND_ACCESS"],
        oktaGroupsLimited: ["TCT2021_FREE_ACCESS"],
    },
    "tct2023-archive": {
        craftId: 24,
        emmaId: 199,
        timezone: { value: "America/Los_Angeles", label: "Pacific U.S." },
        isArchived: true,
        oktaGroupsGeneral: [
            "TCT-2023_ALL_ACCESS",
            "TCT-2023_ONLINE_ACCESS",
            "TCTMD-GOLD-USERS",
            "TCTMD-PLATINUM-USERS",
            "TCT-2023_EXHIBITORS",
            "TCT-2023_MEDTECH",
        ],
    },
    "tct2023-test": {
        craftId: 24,
        emmaId: 199,
        timezone: { value: "America/Los_Angeles", label: "Pacific U.S." },
        oktaGroupsGeneral: [],
    },
    "tct2024-archive": {
        craftId: 34,
        emmaId: 215,
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
    },
    "pulsegala2025-archive": {
        craftId: 57,
        emmaId: 0,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
    },
    pulsegala2026: {
        craftId: 65,
        emmaId: 0,
        fullDomain: "www.pulsegala.org",
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
    },
    "tct2025-archive": {
        craftId: 47,
        emmaId: 226,
        timezone: { value: "America/Los_Angeles", label: "Pacific U.S." },
        oktaGroupsGeneral: [],
    },
    tct2026: {
        craftId: 62,
        emmaId: 234,
        timezone: { value: "America/Los_Angeles", label: "Pacific U.S." },
        oktaGroupsGeneral: [],
    },
    tct2027Std: {
        craftId: 73,
        emmaId: 234,
        fullDomain: "www.tctconference.com",
        timezone: { value: "America/Los_Angeles", label: "Pacific U.S." },
        oktaGroupsGeneral: [],
    },
    "tctmiddleeast2025-archive": {
        craftId: 42,
        emmaId: 223,
        timezone: { value: "Asia/Riyadh", label: "Arabia Standard Time" },
        oktaGroupsGeneral: [],
    },
    tctmiddleeast2026: {
        craftId: 55,
        emmaId: 233,
        fullDomain: "www.tctplusme.com",
        timezone: { value: "Asia/Riyadh", label: "Arabia Standard Time" },
        oktaGroupsGeneral: [],
    },
    tctmiddleeast2027: {
        craftId: 72,
        emmaId: 233,
        timezone: { value: "Asia/Riyadh", label: "Arabia Standard Time" },
        oktaGroupsGeneral: [],
    },
    "tct2023-industry-archive": {
        craftId: 19,
        isArchived: true,
        timezone: { value: "America/Los_Angeles", label: "Pacific U.S." },
        oktaGroupsGeneral: [],
    },
    "tct2024-industry-archive": {
        craftId: 39,
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
    },
    "tct2025-industry-archive": {
        craftId: 48,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
    },
    "tct2026-industry": {
        craftId: 63,
        emmaId: 234,
        fullDomain: "www.tctindustry.com",
        timezone: { value: "America/Los_Angeles", label: "Pacific U.S." },
        oktaGroupsGeneral: [],
    },
    "complications2023-archive": {
        craftId: 25,
        emmaId: 202,
        isArchived: true,
        timezone: { value: "America/Los_Angeles", label: "Pacific U.S." },
        oktaGroupsGeneral: [],
    },
    "complications2024-archive": {
        craftId: 38,
        emmaId: 213,
        isArchived: true,
        timezone: { value: "America/Los_Angeles", label: "Pacific U.S." },
        oktaGroupsGeneral: [],
    },
    "complications2025-archive": {
        craftId: 46,
        emmaId: 229,
        timezone: { value: "America/Los_Angeles", label: "Pacific U.S." },
        oktaGroupsGeneral: [],
    },
    "complications2026-archive": {
        craftId: 60,
        emmaId: 237,
        isArchived: true,
        timezone: { value: "America/Los_Angeles", label: "Pacific U.S." },
        oktaGroupsGeneral: [],
    },
    complications2026postconf: {
        craftId: 69,
        emmaId: 237,
        fullDomain: "www.interventionalcomplications.com",
        timezone: { value: "America/Los_Angeles", label: "Pacific U.S." },
        oktaGroupsGeneral: [],
    },
    tctpluslatam2026: {
        craftId: 61,
        emmaId: 0,
        fullDomain: "login.tctpluslatam.com",
        timezone: { value: "America/Fortaleza", label: "Brasília Time" },
        oktaGroupsGeneral: [],
    },
    "tvt2023-archive": {
        craftId: 20,
        emmaId: 197,
        isArchived: true,
        timezone: { value: "America/Phoenix", label: "Mountain U.S." },
        oktaGroupsGeneral: ["TCTMD-GOLD-USERS", "TCTMD-PLATINUM-USERS"],
    },

    "cto2023-archive": {
        craftId: 16,
        emmaId: 196,
        cfsSlug: "cto2023",
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
    },
    "cto2024-archive": {
        craftId: 26,
        emmaId: 206,
        cfsSlug: "cto2024",
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
    },
    "cto2025-archive": {
        craftId: 41,
        emmaId: 225,
        cfsSlug: "cto2025",
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
    },
    "cto2026-archive": {
        craftId: 53,
        emmaId: 232,
        cfsSlug: "cto2026",
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
    },
    complexcoronary2027: {
        craftId: 64,
        emmaId: 240,
        fullDomain: "www.complexcoronarysummit.com",
        cfsSlug: "complexcoronary2027",
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
    },
    "tct2022-industry-archive": {
        craftId: 13,
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
    },
    "tct2022-archive": {
        craftId: 11,
        emmaId: 191,
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [
            "TCT-2022_ALL_ACCESS",
            "TCT-2022_ONLINE_ACCESS",
            "TCT-2022_EXHIBITORS",
            "TCTMD-GOLD-USERS",
            "TCTMD-PLATINUM-USERS",
        ],
    },
    "complications2022-archive": {
        craftId: 14,
        emmaId: 190,
        isArchived: true,
        timezone: { value: "America/Los_Angeles", label: "Pacific U.S." },
        oktaGroupsGeneral: ["TCTMD-GOLD-USERS", "TCTMD-PLATINUM-USERS"],
    },
    "tvt2022-archive": {
        craftId: 12,
        emmaId: 189,
        isArchived: true,
        timezone: { value: "America/Chicago", label: "Central U.S." },
        oktaGroupsGeneral: ["TCTMD-GOLD-USERS", "TCTMD-PLATINUM-USERS"],
    },

    "cto2022-archive": {
        craftId: 9,
        emmaId: 187,
        cfsSlug: "cto2022",
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: ["TCTMD-GOLD-USERS", "TCTMD-PLATINUM-USERS"],
    },
    "tht2022-archive": {
        craftId: 7,
        emmaId: 178,
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [
            "THT-2022_ALL_ACCESS",
            "THT-2022_ONLINE_ACCESS",
            "TCTMD-GOLD-USERS",
            "TCTMD-PLATINUM-USERS",
        ],
    },
    "complications2021-archive": {
        craftId: 6,
        emmaId: 181,
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
    },
    "tvt2021-archive": {
        craftId: 4,
        emmaId: 176,
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
        oktaGroupsLimited: [],
    },
    "nyvalves2024-archive": {
        craftId: 32,
        emmaId: 208,
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: ["TCTMD-GOLD-USERS", "TCTMD-PLATINUM-USERS"],
    },
    "nyvalves2025-archive": {
        craftId: 44,
        emmaId: 224,
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
        oktaGroupsLimited: [],
    },
    nyvalves2026: {
        craftId: 59,
        emmaId: 231,
        fullDomain: "www.nyvalvesconference.com",
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
        oktaGroupsLimited: [],
    },
    nyvalves2027: {
        craftId: 70,
        emmaId: 0,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
        oktaGroupsLimited: [],
    },
    "fellows2021-archive": {
        craftId: 2,
        emmaId: 179,
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: [],
    },
    "fellows2022-archive": {
        craftId: 10,
        emmaId: 188,
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: ["TCTMD-GOLD-USERS", "TCTMD-PLATINUM-USERS"],
    },
    "fellows2023-archive": {
        craftId: 17,
        emmaId: 200,
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: ["TCTMD-GOLD-USERS", "TCTMD-PLATINUM-USERS"],
    },
    "fellows2024-archive": {
        craftId: 31,
        emmaId: 207,
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: ["TCTMD-GOLD-USERS", "TCTMD-PLATINUM-USERS"],
    },
    "fellows2025-archive": {
        craftId: 43,
        emmaId: 227,
        isArchived: true,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: ["TCTMD-GOLD-USERS", "TCTMD-PLATINUM-USERS"],
    },
    fellows2026: {
        craftId: 56,
        emmaId: 235,
        fullDomain: "www.fellowscourse.com",
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: ["TCTMD-GOLD-USERS", "TCTMD-PLATINUM-USERS"],
    },
    fellows2027: {
        craftId: 71,
        emmaId: 235,
        timezone: { value: "America/New_York", label: "Eastern U.S." },
        oktaGroupsGeneral: ["TCTMD-GOLD-USERS", "TCTMD-PLATINUM-USERS"],
    },
    tctafrica2027: {
        craftId: 49,
        emmaId: 238,
        fullDomain: "www.tctplusafrica.com",
        timezone: { value: "Africa/Tunis", label: "Central European Standard Time" },
        oktaGroupsGeneral: ["TCTMD-GOLD-USERS", "TCTMD-PLATINUM-USERS"],
    },
}

export default sites
